/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-28 11:31:20
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-28 12:37:22
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/MenuSortableTree/tools.ts
 */
import { randomNumber } from 'src/tools/helper';
import _ from 'lodash';

const dfsFrom = (root) => {
  const { id } = root || {};
  const _root = { id: id || randomNumber(), ...root };
  (_root.children || []).forEach((i) => {
    i = dfsFrom(i);
  });
  return _root;
};

const dataFromServer = (data) => {
  const _data = _.cloneDeep(data || []);
  return _data.map((i) => {
    return dfsFrom(i);
  });
};

const generateNewItem = (params) => {
  return { id: randomNumber(), ...(params || {}) };
};

export { dataFromServer, generateNewItem };
